import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';

@DialogFactory
@Component({
  mixins: [style],
})
export default class SelectProvince extends IPSDialog {
  title = '选择区域';

  width = '600px';

  outProvinceIds = [];

  isReadonly = false;

  confirm = false;

  selectedProvinceIds = [];

  public provinceList: Array<ProvinceList> = [];

  mounted() {
    this.getProvinceList();
  }

  @Watch('provinceList', { deep: true, immediate: true })
  onProvinceListChange(newVal) {
    this.confirm = !!(this.getResults() && this.getResults().length);
  }

  getResults() {
    let result = [];
    this.provinceList.forEach((provinceItem: ProvinceList) => {
      result = result.concat(provinceItem.areaList.filter(areaItem => areaItem.isSelected));
    });
    result = result.map(resultItem => resultItem.areaId);
    return result;
  }

  getProvinceList() {
    IPSService.getProvinceList({
      postParams: {
        outProvinceIds: this.outProvinceIds,
      },
    }).then((response) => {
      (response.list as Array<ProvinceList>).forEach((provinceItem) => {
        provinceItem.areaList.forEach((areaItem) => {
          areaItem = Object.assign(areaItem, { isSelected: this.selectedProvinceIds.includes(areaItem.areaId) });
        });
        const selectCount = provinceItem.areaList.filter(areaItem => areaItem.isSelected).length;
        const unSelectCount = provinceItem.areaList.filter(areaItem => !areaItem.isSelected).length;
        const isAllSelect = provinceItem.areaList.every(areaItem => areaItem.isSelected);
        provinceItem = Object.assign(provinceItem, { isSelected: isAllSelect }, { isIndeterminate: selectCount > 0 && unSelectCount > 0 });
      });
      this.provinceList = response.list;
    });
  }

  renderContent(h: CreateElement): VNode {
    return (
      <div class="province-box">
        {this.provinceList.map((provinceItem, index) => {
          return (
            <el-row class="province-item">
              <el-col span={4}>
                {
                  <el-checkbox indeterminate={provinceItem.isIndeterminate} v-model={provinceItem.isSelected} onChange={val => this.onSelectRegio(val, index)}>
                    {provinceItem.regionName}
                  </el-checkbox>
                }
              </el-col>
              <el-col span={20}>
                {provinceItem.areaList.map((areaItem, i) => {
                  return (
                    <el-checkbox v-model={areaItem.isSelected} onChange={val => this.onAreaSelect(val, index, i)} class="area-item">
                      {areaItem.areaName}
                    </el-checkbox>
                  );
                })}
              </el-col>
            </el-row>
          );
        })}
      </div>
    );
  }

  onSelectRegio(val, index) {
    if (val) {
      this.provinceList[index].areaList.map(areaItem => (areaItem.isSelected = true));
    } else {
      this.provinceList[index].areaList.map(areaItem => (areaItem.isSelected = false));
    }
    this.provinceList[index].isIndeterminate = false;
  }

  onAreaSelect(val, parentIndex, index) {
    this.provinceList[parentIndex].isSelected = this.provinceList[parentIndex].areaList.every(areaItem => areaItem.isSelected);
    const selectCount = this.provinceList[parentIndex].areaList.filter(areaItem => areaItem.isSelected).length;
    const unSelectCount = this.provinceList[parentIndex].areaList.filter(areaItem => !areaItem.isSelected).length;
    this.provinceList[parentIndex].isIndeterminate = selectCount > 0 && unSelectCount > 0;
  }
}
